<template>
    <div>
        <iframe class="trip-frame" src="https://hk.trip.com/partners/ad/S795?Allianceid=1113293&SID=2592545&ouid=" frameborder="0" scrolling="no" id="S795"></iframe>
        <iframe class="trip-frame-md" src="https://hk.trip.com/partners/ad/S796?Allianceid=1113293&SID=2592545&ouid=" frameborder="0" scrolling="no" id="S796"></iframe>
    </div>

</template>

<script>
    export default {
        props: {

        },

        data(){
            return{

            }
        },

        methods(){

        },

        mounted() {
        }
    }

</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";

    .trip-frame{
        height: 209px;
        width: 100%;
        @include responsive(){
            display: none;
        }
    }

    .trip-frame-md{
        display: none;
        @include responsive(){
            height: 300px;
            display: unset;
        }
    }
</style>